module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1'), _c('h1'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.setDetails.name)), _c('small', [_vm._v(_vm._s(_vm.setDetails.description))])]), _vm._v(" "), _c('div', {
    staticClass: "flexbin flexbin-margin"
  }, _vm._l((_vm.imageItems), function(image) {
    return _c('a', {
      directives: [{
        name: "lightbox",
        rawName: "v-lightbox"
      }],
      attrs: {
        "href": image.urlLarge
      }
    }, [_c('img', {
      attrs: {
        "src": image.urlSmall
      }
    })])
  }))])]), _vm._v(" "), _c('lightbox')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-393c251a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PhotoSet.vue
// module id = 441
// module chunks = 1